import { render, staticRenderFns } from "./scopeDetail.vue?vue&type=template&id=26de8e7b&"
import script from "./scopeDetail.vue?vue&type=script&lang=js&"
export * from "./scopeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports